import { Button, Divider, FormControl, Grid, Stack, TextField, Typography } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useFormik } from 'formik';
import { IconFileSpreadsheet } from '@tabler/icons';
import { schedules } from 'services/report';

const SchedulesReport = () => {
    const formik = useFormik({
        initialValues: {
            start_date: null,
            end_date: null
        },
        onSubmit: (values) => {
            schedules({ start: values.start_date, end: values.end_date })
                .then((response) => {
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'relatorio_agendamentos.xlsx');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h3">Relatório de Agendamentos</Typography>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
                            <DateTimePicker
                                variant="standard"
                                label="Data de Início"
                                type="date"
                                name="start_date"
                                id="start_date"
                                value={formik.values.start_date}
                                onChange={(date) => formik.setFieldValue('start_date', date)}
                                ampm={false}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                inputFormat={'DD/MM/yyyy HH:mm'}
                                minutesStep={5}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
                            <DateTimePicker
                                variant="standard"
                                label="Data de Término"
                                type="date"
                                name="end_date"
                                id="end_date"
                                value={formik.values.end_date}
                                onChange={(date) => formik.setFieldValue('end_date', date)}
                                ampm={false}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                inputFormat={'DD/MM/yyyy HH:mm'}
                                minutesStep={5}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <Button variant="contained" color="success" type="submit" startIcon={<IconFileSpreadsheet />} size="large">
                            Gerar Relatório
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </form>
    );
};

export default SchedulesReport;
